import instance from './DefaultApi';

export default class DeMappingReportService {
    ControllerName = 'DemappingReport';

    // create de map data
    GetDemappingReport(tableRequest) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDemappingReport`, tableRequest).then(res => res)
    }   
}